<!-- <div class="fixed-width support-tab tournament-tab">
  <mat-tab-group mat-stretch-tabs [selectedIndex]="tabIndex" (selectedTabChange)="onTabChange($event)">
    <mat-tab>
      <ng-template mat-tab-label>
        <img src="assets/desktop/tournament/how-it-works.svg">
        <span i18n>How it works?</span>
      </ng-template>
      <app-how-mission-works [mission]="mission"></app-how-mission-works>
    </mat-tab>
    <mat-tab>
      <ng-template mat-tab-label>
        <img src="assets/desktop/tournament/leaderboard.svg">
        <span i18n>Leaderboard</span>
      </ng-template>
      <app-leader-board [ref]="mission.ref" [tournament]="mission"></app-leader-board>
    </mat-tab>
    <mat-tab>
      <ng-template mat-tab-label>
        <img src="assets/desktop/tournament/prizes.svg">
        <span i18n>Prizes</span>
      </ng-template>
      <app-prizes-scoring [tournament]="mission"></app-prizes-scoring>
    </mat-tab>
    <mat-tab>
      <ng-template mat-tab-label>
        <img src="assets/desktop/tournament/scoring.svg">
        <span i18n>Scoring</span>
      </ng-template>
      <app-points-scoring [tournament]="mission"></app-points-scoring>
    </mat-tab>
  </mat-tab-group>
</div> -->
<app-how-mission-works [mission]="mission"></app-how-mission-works>
